import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { AppDataActions } from '../redux/app-data';
import MainLayout from './main/main-layout';
import { ePerformanceMeasure, eElasticEvent } from '../utils/enums';
import PerformanceFacade from '../utils/performance/performance-facade';
import { getLogDataFromUserContext } from '../services/clickstream-service/utils';

if (process.env.BROWSER) {
  require('./app.scss');

  //const loading = () => <div></div>;
  /*const MainLayoutLoadable = Loadable({
  loader: () => import('./main/main-layout'),
  loading,
});*/
}

class App extends React.Component {
  componentDidMount() {
    this.props.loadSports();

    if (process.env.BROWSER) {
      const { userContext } = this.props;

      window.onload = () => {
        PerformanceFacade.sendDurationReport(
          eElasticEvent.WindowOnLoad,
          getLogDataFromUserContext(userContext),
          ePerformanceMeasure.WindowOnLoad
        );
      };

      document.addEventListener('DOMContentLoaded', () => {
        PerformanceFacade.sendDurationReport(
          eElasticEvent.DOMContentLoaded,
          getLogDataFromUserContext(userContext),
          ePerformanceMeasure.DOMContentLoaded
        );
      });
    }
  }

  render() {
    const { kambiConfigData } = this.props;
    return <MainLayout kambiConfigData={kambiConfigData} />;
  }
}

App.propTypes = {
  kambiConfigData: PropTypes.object.isRequired,
  loadSports: PropTypes.func,
  userContext: PropTypes.object
};

function mapStateToProps(state) {
  const { userContext } = state;

  return { userContext };
}

const mapDispatchToProps = dispatch => {
  return {
    loadSports: () => dispatch(AppDataActions.loadSports())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
